import axios from "axios";
import config from "../config";

export const API_URL = config.API;

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

$api.interceptors.request.use((config) => {
  // @ts-ignore
  config.headers!.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

export default $api;
